// @flow
import React, { Component } from "react";
import store from "../../store";

const default_color = {
  primary: "#3a9d48",
  secondary: "#4ebd5d",
  third: "#81d48c",
};

export const ColorSchema = (choose: string): string => {
  //const color = store.getState().forensic.db.conference[choose];
  const conference = store.getState().forensic.db.conference;
  if (conference) {
    if (conference.theme) {
      if (choose === "primary") {
        return conference.theme.primary_dark;
      }
      else if (choose === "secondary") {
        return conference.theme.primary_medium;
      }
      else {
        return conference.theme.primary_light;
      }
    }
  }
  return default_color[choose];
};

export const WhiteText = "#ffffff";
export const BlackText = "#121213";
export const GreyText = "#8a8a8a";
export const GreyLightText = "#dddddd";
export const InvalidText = "#ec3f41";
export const ValidText = "#3a7d34";



// WEBPACK FOOTER //
// ./src/global/types/scss.js